import React, { forwardRef, ReactNode } from 'react'
import { func, element, bool } from 'prop-types'
import Icon from 'components/uiElements/Icon'
import useOutsideAlerter from 'hooks/useOutsideAlerter'

require('./TheaterModal.scss')

interface TheaterModalProps {
    onClose: () => void
    isOpen: boolean
    children: ReactNode
}

const TheaterModal = forwardRef<HTMLDivElement, TheaterModalProps>((props, ref) => {
    const { onClose, children, isOpen } = props

    // If the user clicks outside, the modal is closed
    useOutsideAlerter(ref, onClose)

    return (
        <div className="TheaterModal">
            {isOpen && (
                <div className="theaterModalContainer" ref={ref}>
                    <div className="theaterModalContent">
                        <button
                            onClick={onClose}
                            className="theaterModalCloseBtn"
                            data-testid="theater-modal-close-btn"
                        >
                            <Icon code="cross" />
                        </button>

                        <div className="theaterModalChildren">{children}</div>
                    </div>
                </div>
            )}
        </div>
    )
})

TheaterModal.propTypes = {
    onClose: func.isRequired,
    children: element.isRequired,
    isOpen: bool.isRequired,
}

export default TheaterModal
